// export const transformSinglePO = (po = {}) => {
//   // console.log("Transforming PO:...............................", po);



//   const toDateTimeLocal = (val) => {
//     if (!val) return "";
//     const d = new Date(val);
//     return isNaN(d) ? "" : d.toISOString().slice(0, 16);
//   };


//   const poHdr = po.purchase_order || {};
//   const buyer = po.buyer || {};
//   const buyerAddr = buyer.address || {};
//   const supplier = po.supplier || {};
//   const supplierAddr = supplier.address || {};
//   const misc = po.misc || {};
//   const loading = po.loading || {};
//   const udf = po.udf || {};

//   const detailItems = (po.lineItems || []).map((li, idx) => {
//     const d = li.detail || {};
//     const u = li.udf || {};
//     const extra = li.extra_udf || {};
//     const lineNumber = d.lineNumber ?? idx + 1;

//     return {
//       id: li._id || d._id || `line-${po._id}-${idx}`,
//       lineNo: String(lineNumber).padStart(5, "0"),
//       purchaseOrder: d.purchaseOrder || "",
      
//       skuId: d.skuId,
//       item: d.skuId,
//       description: d.description || "",
//       itemCube: d.itemCube ?? "",
//       itemWeight: d.itemWeight ?? "",
//       supplierLot: d.supplierLot || "",
//       pack: d.pack || "",
//       orderedQty: d.orderedQty ?? 0,
//       openQty: d.openQty ?? 0,
//       itemPOTolerance: d.itemPOTolerance ?? 0,
//       unitPrice: d.unitPrice ?? 0,
//       discount: d.discount ?? 0,
//       tax: d.tax ?? 0,
//       totalPrice: d.totalPrice ?? 0,
//       receivedQty: d.receivedQty ?? 0,
//       uom: d.uom || "",
//       qcRequired: d.qcRequired === undefined ? false : d.qcRequired,
//       qcAutoAdjust: d.qcAutoAdjust ?? false,
//       status: li.status || "",
//       poLineUdf1: u.poLineUDF1 ?? u.poLineUdf1 ?? "",
//       poLineUdf2: u.poLineUDF2 ?? u.poLineUdf2 ?? "",
//       poLineUdf3: u.poLineUDF3 ?? u.poLineUdf3 ?? "",
//       poLineUdf4: u.poLineUDF4 ?? u.poLineUdf4 ?? "",
//       poLineUdf5: u.poLineUDF5 ?? u.poLineUdf5 ?? "",
//       notes: u.notes ?? li.notes ?? "",
//       purchaseOrderTextUDF1: extra.purchaseOrderTextUDF1 || "",
//       purchaseOrderTextUDF2: extra.purchaseOrderTextUDF2 || "",
//       purchaseOrderTextUDF3: extra.purchaseOrderTextUDF3 || "",
//       purchaseOrderTextUDF4: extra.purchaseOrderTextUDF4 || "",
//       purchaseOrderTextUDF5: extra.purchaseOrderTextUDF5 || "",
//       raw: li,
//     };
//   });

//   return {
//     id: poHdr.orderId,
//     _id: po._id,
//     createdAt: toDateTimeLocal(po.createdAt),
//     buyerName: poHdr.buyerName || "",
//     purchaseOrder: poHdr.orderId || "",
//     externalPoNumber: poHdr.externalPoNumber || "-",
//     purchasingOfficeLocation: poHdr.purchasingOfficeLocation || "",
//     openQuantity: poHdr.openQuantity ?? "",
//     totalPOPrice: poHdr.totalPOPrice ?? 0,
//     source: poHdr.source || "",
//     status: poHdr.status,
//     type: poHdr.type || "Standard",
//     totalWeight: poHdr.totalWeight ?? 0,
//     totalVolume: poHdr.totalVolume ?? 0,
//     totalOrderedQuantity: poHdr.totalOrderedQuantity ?? 0,
//     buyerOwner: buyer.buyer || "",
//     purchaseOrderDate: poHdr.purchaseOrderDate
//       ? new Date(poHdr.purchaseOrderDate).toLocaleString()
//       : "",
//     expectedReceiptDate: poHdr.expectedReceiptDate
//       ? new Date(poHdr.expectedReceiptDate).toLocaleDateString()
//       : "",
//     validityDate : poHdr.validityDate
//       ? new Date(poHdr.validityDate).toLocaleDateString()
//       : "",
//     closedDate: poHdr.closedDate
//       ? new Date(poHdr.closedDate).toISOString().slice(0, 10)
//       : "",
//     otherReference: poHdr.otherReference || "",

//     // ASN numbers
//     asnNumbers: (() => {
//       const asnArr = po.asnHistory || po.purchase_order?.asnHistory || [];
//       if (!Array.isArray(asnArr) || asnArr.length === 0) return "";
//       return asnArr.map((a) => a?.asnNumber).filter(Boolean).join(", ");
//     })(),

//     // Buyer address
//     buyerAddressLine1: buyerAddr.addressLine1 || "",
//     buyerAddressLine2: buyerAddr.addressLine2 || "",
//     buyerAddressLine3: buyerAddr.addressLine3 || "",
//     buyerAddressLine4: buyerAddr.addressLine4 || "",
//     buyerCity: buyerAddr.city || "",
//     buyerCountry: buyerAddr.country || "",
//     buyerState: buyerAddr.state || "",
//     buyerZip: buyerAddr.zip || "",
//     buyerEmail: buyerAddr.email || "",
//     buyerContact: buyerAddr.contact || "",

//     // Supplier
//     supplier: supplier.supplier || "",
//     addressLine1: supplierAddr.addressLine1 || "",
//     addressLine2: supplierAddr.addressLine2 || "",
//     addressLine3: supplierAddr.addressLine3 || "",
//     addressLine4: supplierAddr.addressLine4 || "",
//     city: supplierAddr.city || "",
//     country: supplierAddr.country || "",
//     state: supplierAddr.state || "",
//     zip: supplierAddr.zip || "",
//     vat: supplierAddr.vatNumber || "",
//     supplierReference: poHdr.otherReference || "",
//     email: supplierAddr.email || "",
//     contact: supplierAddr.contact || "",

//     // Header UDFs
//     poHeaderUdf1: misc.poHeaderUDF1 || "",
//     poHeaderUdf2: misc.poHeaderUDF2 || "",
//     poHeaderUdf3: misc.poHeaderUDF3 || "",
//     poHeaderUdf4: misc.poHeaderUDF4 || "",
//     poHeaderUdf5: misc.poHeaderUDF5 || "",
//     apportionRule: misc.apportionRule || "",
//     notes: misc.notes || "",

//     // Other
//     loadingDate: loading.loadingDate
//       ? new Date(loading.loadingDate).toISOString().slice(0, 10)
//       : "",
//     carrier: loading.carrier || "",
//     placeOfLoading: loading.placeOfLoading || "",
//     placeOfDelivery: loading.placeOfDelivery || "",
//     placeOfDischarge: loading.placeOfDischarge || "",
//     countryOfOrigin: loading.countryOfOrigin || "",
//     countryOfDestination: loading.countryOfDestination || "",
//     termsOfDelivery: loading.termsOfDelivery || "",
//     termsOfPayment: loading.termsOfPayment || "",

//     // Custom fields
//     customField1: udf.purchaseOrderTextUDF1 || "",
//     customField2: udf.purchaseOrderTextUDF2 || "",
//     customField3: udf.purchaseOrderTextUDF3 || "",
//     customNotes: udf.purchaseOrderTextUDF4 || "",
//     customField5: udf.purchaseOrderNumericUDF1 ?? "",
//     customField4: udf.purchaseOrderDateUDF1
//       ? new Date(udf.purchaseOrderDateUDF1).toISOString().slice(0, 10)
//       : "",

//     detailItems,
//     raw: po,
//   };
// };





export const transformSinglePO = (po = {}) => {

  const toDateTimeLocal = (val) => {
    if (!val) return "";
    const d = new Date(val);
    return isNaN(d) ? "" : d.toISOString().slice(0, 16);
  };

  const poHdr = po.purchase_order || {};
  const buyer = po.buyer || {};
  const buyerAddr = buyer.address || {};
  const supplier = po.supplier || {};
  const supplierAddr = supplier.address || {};
  const misc = po.misc || {};
  const loading = po.loading || {};
  const udf = po.udf || {};

  /* ---------------- LINE ITEMS ---------------- */
  const detailItems = (po.lineItems || []).map((li, idx) => {
    const d = li.detail || {};
    const u = li.udf || {};
    const extra = li.extra_udf || {};
    const lineNumber = d.lineNumber ?? idx + 1;

    return {
      id: li._id || d._id || `line-${po._id}-${idx}`,
      lineNo: String(lineNumber).padStart(5, "0"),
      purchaseOrder: d.purchaseOrder || "",
      skuId: d.skuId || "",
      item: d.skuId || "",
      description: d.description || "",
      itemCube: d.itemCube ?? "",
      itemWeight: d.itemWeight ?? "",
      supplierLot: d.supplierLot || "",
      pack: d.pack || "",
      lpnNo: d.lpnNo || d.lpn || "",
      batchNum: d.batchNum || d.batchNo || d.batchNumber || "",
      orderedQty: d.orderedQty ?? 0,
      openQty: d.openQty ?? 0,
      itemPOTolerance: d.itemPOTolerance ?? 0,
      unitPrice: d.unitPrice ?? 0,
      discount: d.discount ?? 0,
      tax: d.tax ?? 0,
      totalPrice: d.totalPrice ?? 0,
      receivedQty: d.receivedQty ?? 0,
      uom: d.uom || "",
      qcRequired: d.qcRequired ?? "No",
      qcAutoAdjust: d.qcAutoAdjust ?? false,
      status: li.status || "New",

      poLineUdf1: u.poLineUDF1 ?? "",
      poLineUdf2: u.poLineUDF2 ?? "",
      poLineUdf3: u.poLineUDF3 ?? "",
      poLineUdf4: u.poLineUDF4 ?? "",
      poLineUdf5: u.poLineUDF5 ?? "",

      purchaseOrderTextUDF1: extra.textUDF1 ?? "",
      purchaseOrderTextUDF2: extra.textUDF2 ?? "",
      purchaseOrderTextUDF3: extra.textUDF3 ?? "",
      purchaseOrderTextUDF4: extra.textUDF4 ?? "",
      purchaseOrderTextUDF5: extra.textUDF5 ?? "",

      raw: li,
    };
  });

  /* ---------------- FINAL RETURN ---------------- */
  return {
    /* IDs */
    id: poHdr.orderId || "",
    _id: po._id,

    /* HEADER */
    purchaseOrder: poHdr.orderId || "",
    buyerName: poHdr.buyerName || "",
    externalPoNumber: poHdr.externalPoNumber || "",
    purchasingOfficeLocation: poHdr.purchasingOfficeLocation || "",
    type: poHdr.type || "Standard",
    status: poHdr.status || "New",
    source: poHdr.source || "INTERNAL",

    /* ✅ MAIN FIX (REFERENCES) */
    buyersReference:
      poHdr.buyersReference ||
      buyerAddr.buyersReference ||
      "",

    sellersReference:
      poHdr.sellersReference ||
      supplierAddr.sellersReference ||
      "",

    /* DATES */
    createdAt: toDateTimeLocal(po.createdAt),
    purchaseOrderDate: poHdr.purchaseOrderDate
      ? new Date(poHdr.purchaseOrderDate).toISOString().slice(0, 10)
      : "",
    expectedReceiptDate: poHdr.expectedReceiptDate
      ? new Date(poHdr.expectedReceiptDate).toISOString().slice(0, 10)
      : "",
    validityDate: poHdr.validityDate
      ? new Date(poHdr.validityDate).toISOString().slice(0, 10)
      : "",
    closedDate: poHdr.closedDate
      ? new Date(poHdr.closedDate).toISOString().slice(0, 10)
      : "",

    /* TOTALS */
    openQuantity: String(poHdr.openQuantity ?? 0),
    totalWeight: poHdr.totalWeight ?? 0,
    totalVolume: poHdr.totalVolume ?? 0,
    totalPOPrice: poHdr.totalPOPrice ?? 0,
    totalOrderedQuantity: poHdr.totalOrderedQuantity ?? 0,

    /* BUYER */
    buyerOwner: buyer.buyer || "",
    buyerAddressLine1: buyerAddr.addressLine1 || "",
    buyerAddressLine2: buyerAddr.addressLine2 || "",
    buyerAddressLine3: buyerAddr.addressLine3 || "",
    buyerAddressLine4: buyerAddr.addressLine4 || "",
    buyerCity: buyerAddr.city || "",
    buyerState: buyerAddr.state || "",
    buyerCountry: buyerAddr.country || "",
    buyerZip: buyerAddr.zip || "",

    /* SUPPLIER — payload sends supplier_id, the name stays on the form */
    supplierId: supplier.supplier_id || supplier.supplierId || "",
    supplier: supplier.supplier || "",
    addressLine1: supplierAddr.addressLine1 || "",
    addressLine2: supplierAddr.addressLine2 || "",
    addressLine3: supplierAddr.addressLine3 || "",
    addressLine4: supplierAddr.addressLine4 || "",
    city: supplierAddr.city || "",
    state: supplierAddr.state || "",
    country: supplierAddr.country || "",
    zip: supplierAddr.zip || "",
    vat: supplierAddr.vatNumber || "",

    /* MISC */
    poHeaderUdf1: misc.poHeaderUDF1 || "",
    poHeaderUdf2: misc.poHeaderUDF2 || "",
    poHeaderUdf3: misc.poHeaderUDF3 || "",
    poHeaderUdf4: misc.poHeaderUDF4 || "",
    poHeaderUdf5: misc.poHeaderUDF5 || "",
    apportionRule: misc.apportionRule || "",
    notes: misc.notes || "",

    /* LOADING */
    loadingDate: loading.loadingDate
      ? new Date(loading.loadingDate).toISOString().slice(0, 10)
      : "",
    carrier: loading.carrier || "",
    placeOfLoading: loading.placeOfLoading || "",
    placeOfDelivery: loading.placeOfDelivery || "",
    placeOfDischarge: loading.placeOfDischarge || "",
    countryOfOrigin: loading.countryOfOrigin || "",
    countryOfDestination: loading.countryOfDestination || "",
    termsOfDelivery: loading.termsOfDelivery || "",
    termsOfPayment: loading.termsOfPayment || "",

    /* UDF */
    customField1: udf.textUDF1 || "",
    customField2: udf.textUDF2 || "",
    customField3: udf.textUDF3 || "",
    customNotes: udf.textUDF4 || "",
    customField5: udf.numericUDF1 ?? "",
    customField4: udf.dateUDF1
      ? new Date(udf.dateUDF1).toISOString().slice(0, 10)
      : "",

    /* ITEMS */
    detailItems,

    raw: po,
  };
};
